var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingEventIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#ADF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2875 9.60664C13.2875 10.7056 12.8509 11.7596 12.0738 12.5367C11.2967 13.3138 10.2427 13.7504 9.14375 13.7504C8.04476 13.7504 6.99078 13.3138 6.21368 12.5367C5.43657 11.7596 5 10.7056 5 9.60664C5 8.50765 5.43657 7.45367 6.21368 6.67657C6.99078 5.89946 8.04476 5.46289 9.14375 5.46289C10.2427 5.46289 11.2967 5.89946 12.0738 6.67657C12.8509 7.45367 13.2875 8.50765 13.2875 9.60664Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14414 12.2875C8.43303 12.2875 7.75104 12.005 7.24821 11.5022C6.74538 10.9993 6.46289 10.3174 6.46289 9.60625C6.46289 8.89514 6.74538 8.21315 7.24821 7.71032C7.75104 7.20749 8.43303 6.925 9.14414 6.925M9.14414 9.60625L10.6066 7.4125M9.87539 4.73125C9.87539 4.53731 9.79835 4.35131 9.66121 4.21418C9.52408 4.07704 9.33808 4 9.14414 4C8.9502 4 8.7642 4.07704 8.62707 4.21418C8.48993 4.35131 8.41289 4.53731 8.41289 4.73125C8.41289 4.92519 8.48993 5.11119 8.62707 5.24832C8.7642 5.38546 8.9502 5.4625 9.14414 5.4625C9.33808 5.4625 9.52408 5.38546 9.66121 5.24832C9.79835 5.11119 9.87539 4.92519 9.87539 4.73125Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingEventIcon);
export default __webpack_public_path__ + "static/media/UpcomingEventIcon.b5962e4a9227b12fb34d7d677d56f2dd.svg";
export { ForwardRef as ReactComponent };